import { render, staticRenderFns } from "./ResultQuestionB.vue?vue&type=template&id=3c5f1a80&"
import script from "./ResultQuestionB.vue?vue&type=script&lang=js&"
export * from "./ResultQuestionB.vue?vue&type=script&lang=js&"
import style0 from "./ResultQuestionB.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VApp,VBtn})
